<template>
  <div class='apply-refund'>
    <sub-nav :navs='navs'/>
    <h2 class='title'>申请退款</h2>
    <div v-loading='loading' class='content'>
      <h3>{{ order.book_name }}</h3>
      <!-- 订单信息 -->
      <ul>
        <li>
          <span class='label'>书号:</span>
          <span class='val'>{{ order.book_no }}</span>
        </li>
        <li>
          <span class='label'>批发单号:</span>
          <span class='val'>{{ order.wholesale_no }}</span>
        </li>
        <li>
          <span class='label'>索引号:</span>
          <span class='val'>{{ order.indexes }}</span>
        </li>
      </ul> 
      <ul> 
        <li>
          <span class='label'>学校：</span>
          <span class='val'>{{ order.school }}</span>
        </li>
        <li>
          <span class='label'>院系：</span>
          <span class='val'>{{ order.department }}</span>
        </li>
        <li>
          <span class='label'>年级-专业班级：</span>
          <span class='val'>{{ order.profession_class }}</span>
        </li>
      </ul> 
      <ul> 
        <li>
          <span class='label'>姓名：</span>
          <span class='val'>{{ user.name }}</span>
        </li>
        <li>
          <span class='label'>学号：</span>
          <span class='val'>{{ user.student_num }}</span>
        </li>
        <li/>
      </ul>
      <ul class='price-info-wrapper'>    
        <li>
          <span class='label'>单价：</span>
          <span class='val'>{{ order.price }}</span>
        </li>
        <li>
          <span class='label'>折扣：</span>
          <span class='val'>{{ order.discount }}</span>
        </li>
        <li>
          <span class='label'>数量：</span>
          <span class='val'>{{ order.pay_num }}套</span>
        </li>
        <li class='price-info'>
          <span class='label'>实付款：</span>
          <span class='val'>￥{{ order.pay_money }}</span>
        </li>
      </ul>
      <!-- 退款操作 -->
      <ul class='operation'>
        <li class='nums'>
          <div class='num-wrapper'>
            <span class='label'>退款数量：</span>
            <div class='btn-wrapper'>
              <i class='iconfont icon-minus' @click='minusRefundNum'/>
              <input v-model='refundNum' type='tel' @change='inputRefundNum'>
              <i class='iconfont icon-add' @click='addRefundNum'/>
            </div>
          </div>
          <div class='refund-money'>
            <span class='label'>退款金额：</span>
            <span class='val'>￥{{ refundMoney }}</span>
          </div>
        </li>
        <!-- <li class='refund-ways'>
          <span class='label'>退款途径：</span>
          <div class='img-wrapper' @click='toggleAccountType("WECHAT")'>
            <img v-if='accountType === "WECHAT"' src='../assets/imgs/wechat_on.png' alt='' class='icon'>
            <img v-else src='../assets/imgs/wechat_off.png' alt='' class='icon'>
          </div>
          <div class='img-wrapper' @click='toggleAccountType("ALIPAY")'>
            <img v-if='accountType === "ALIPAY"' src='../assets/imgs/alipay_on.png' alt='' class='icon'>
            <img v-else src='../assets/imgs/alipay_off.png' alt='' class='icon'>
          </div>
        </li> -->
        <!-- <li class='refund-account'>
          <span class='label'>退款账号：</span>
          <input v-model='account' type='text' placeholder='退款账号' class='input'>
        </li> -->
        <li class='refund-reason'>
          <span class='label'>退款原因：</span>
          <textarea v-model='reason' rows='3' placeholder='在此描述问题'/>
        </li>
        <li class='voucher'>
          <span class='label'>退款凭证:</span>
          <!-- 付款单据 -->
          <div class='img-wrapper'>
            <i v-if='!voucherPath' class='iconfont icon-camera'/>
            <img v-else :src='voucherPath' alt='' class='pic-voucher'>
            <input type='file' class='file-uploader' @change='selectVoucher'>
            <span v-if='!voucherPath' class='notice'>上传付款单据</span>
          </div>
          <!-- 退款申请书 -->
          <div class='img-wrapper'>
            <i v-if='!applyFormPath' class='iconfont icon-camera'/>
            <img v-else :src='applyFormPath' alt='' class='pic-voucher'>
            <input type='file' class='file-uploader' @change='selectApplyForm'>
            <span v-if='!applyFormPath' class='notice'>上传退款申请书</span>
          </div>
        </li>
      </ul>

      <!-- 提交按钮 -->
      <div class='submit-btn'>
        <a href='javascript:;' class='btn-submit' @click='submitHandler'>提交</a>
        <a href='javascript:;' class='btn-cancel' @click='goBack'>取消</a>
      </div>
    </div>
  </div>
</template>

<script>
import SubNav from '@/components/SubNav'
import { REFUND, UPLOAD_REFUND_IMG } from '@/api'

export default {
  components: {
    SubNav
  },
  data() {
    return {
      navs: [
        { label: '个人中心', path: '/my' },
        { label: '我的订单', path: '/myorder/ispay' },
      ],
      loading: false,
      voucherPath: '',
      voucherUrl: '',
      applyFormPath: '',
      applyFormUrl: '',
      refundNum: 0,
      reason: '',
      voucherFile: null,
      applyFormFile: null,
      account: '',
      accountType: 'WECHAT', // 退款途径 WECHAT ALIPAY

    }
  },

  computed: {
    
    order() {
      return this.$store.state.refundOrder
    },
    user() {
      return this.$store.state.userInfo
    },

    // 退款金额
    refundMoney() {
      let money = (this.order.price - 0) * (this.order.discount - 0) / 100 * this.refundNum
      return money.toFixed(2)
    },
  },

  created() {
    if (!this.order) this.goBack()
    this.setActiveBar('MY')
  },

  methods: {
    // 切换付款途径
    toggleAccountType(val) {
      this.accountType = val
    },

    // 上传退款凭证
    selectVoucher(e) {
      let file = e.target.files[0]
      let render = new FileReader()
      render.onload = e=>{
        this.voucherFile = file
        this.voucherPath = e.target.result
      }
      render.readAsDataURL(file)
    },

    // 上传退款凭证
    selectApplyForm(e) {
      let file = e.target.files[0]
      let render = new FileReader()
      render.onload = e=>{
        this.applyFormFile = file
        this.applyFormPath = e.target.result
      }
      render.readAsDataURL(file)
    },

    // 提交
    submitHandler() {
      if (!this._volidate()) return
      this.uploadImg()
    },

    // 提交申请
    submitApply() {
      let formData = new FormData()
      formData.append('order_no', this.order.order_no)
      formData.append('num', this.refundNum)
      formData.append('description', this.reason)
      // formData.append('account_type',this.accountType === 'WECHAT' ? 1 : 2)
      // formData.append('account_num', this.account)
      formData.append('voucher_path', this.voucherUrl)
      formData.append('apply_form_path', this.applyFormUrl)
      
      REFUND(formData).then(res=>{
        this.loading = false
        if (res.data.code === 0) {
          this.$notify()
          this.goBack()
        } else {
          this.$notify(res.data.msg, 'error')
        }
      })
    },

    // 上传图片
    uploadImg() {
      this.loading = true
      let formData
      new Promise((resolve,reject)=>{
        formData = new FormData()
        formData.append('file',this.voucherFile)
        UPLOAD_REFUND_IMG(formData).then(res=>{
          if (res.data.code === 0) {
            this.voucherUrl = res.data.data
            resolve()
          }
        })
      }).then(()=>{
        new Promise((resolve,reject)=>{
          formData = new FormData()
          formData.append('file',this.applyFormFile)
          UPLOAD_REFUND_IMG(formData).then(res=>{
            if (res.data.code === 0) {
              this.applyFormUrl = res.data.data
              resolve()
            }
          })
        }).then(()=>{
          this.submitApply()
        })
      })
    },

    // 表单验证
    _volidate() {
      if (!this.refundNum) {
        this.$notify('请输入退款数量','warning')
        return false
      }

      // if (!this.account) {
      //   this.$notify('请输入退款账号','warning')
      //   return false
      // }
      if (!this.reason) {
        this.$notify('请输入退款原因','warning')
        return false
      }
      if (!this.voucherFile) {
        this.$notify('请上传付款凭证','warning')
        return false
      }
      if (!this.applyFormFile) {
        this.$notify('请上传退款申请书','warning')
        return false
      }
      return true
    },

    // 退款数量 -1
    minusRefundNum() {
      if (this.refundNum > 0) this.refundNum --
    },

    // 退款数量 +1
    addRefundNum() {
      if (this.refundNum < this.order.pay_num) this.refundNum ++
    },

    // 输入退款数量
    inputRefundNum(e) {
      let num = e.target.value - 0
      let pay_num = this.order.pay_num - 0
      if (isNaN(num)) {
        this.refundNum = 0  
        return
      }
      if (num > pay_num) {
        this.refundNum = pay_num
        return
      }
      this.refundNum = Math.floor(num)
    },
  },
}
</script>

<style lang="less" scoped>
@import "../assets/css/mixin.less";

.apply-refund {
  width: 1200px;

  h2 {
    text-align: center;
    font-size: 20px;
    color: #000;
    font-weight: 500;
  }

  .content {
    width: 900px;
    height: 790px;
    margin: 30px auto 20px;
    box-sizing: border-box;
    padding: 24px 84px;
    background: @blue-l;
    border-radius: 5px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
    position: relative;

    h3 {
      font-size: 20px;
      color: #000;
      margin-bottom: 18px;
    }
    ul {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;

      li {
        width: 30%;
        height: 42px;
        font-size: 14px;
        display: flex;
        flex-direction: row;
        align-items: center;

        span.label {
          color: #000;
        }
        span.val {
          color: #4d4d4d;
          padding-left: 5px;
        }
      }

      &.price-info-wrapper {
        height: 90px;
        border-top: 1px solid #aaa;
        border-bottom: 1px solid #aaa;
        align-items: flex-start;
        position: relative;

        .price-info {
          position: absolute;
          right: 0;
          bottom: 0;
          .label {
            color: #000;
            font-weight: 500;
          }
          .val {
            font-size: 18px;
            color: #000;
            font-weight: 500;
          }
        }
      }

      // 退款操作
      &.operation {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        padding: 18px 0;

        li {
          height: 42px;
          width: 100%;
          display: flex;
          flex-direction: row;
          align-items: center;

          // 退款数量
          &.nums {
            .num-wrapper {
              width: 250px;
              display: flex;
              flex-direction: row;
              font-size: 14px;
              align-items: center;

              .btn-wrapper {
                width: 102px;
                height: 30px;
                line-height: 30px;
                border-radius: 5px;
                overflow: hidden;
                border: 1px solid #999;
                display: flex;
                flex-direction: row;
                box-sizing: border-box;

                i {
                  display: inline-block;
                  height: 30px;
                  width: 30px;
                  text-align: center;
                  background: @blue-d;
                  color: #fff;
                  cursor: pointer;
                }

                input {
                  display: inline-block;
                  height: 30px;
                  width: 40px;
                  background-color: #fff;
                  outline: none;
                  border: none;
                  font-size: 16px;
                  text-align: center;
                }
              }
            }
            .refund-money {
              .val {
                font-size: 18px;
                color: #000;
              }
            }
          }

          // 退款途径
          &.refund-ways {
            img.icon {
              width: 22px;
              height: 22px;
              margin: 0 5px;
              cursor: pointer;
            }
          }

          // 退款账号
          &.refund-account {
            margin-bottom: 10px;
            input {
              height: 30px;
              line-height: 30px;
              font-size: 14px;
              border: 1px solid #999;
              outline: none;
              flex: 1;
              border-radius: 5px;
              padding: 0 10px;
            }
          }

          &.refund-reason {
            height: 64px;
            align-items: flex-start;
            span.label {
              padding-top: 10px;
            }
            textarea {
              flex: 1;
              resize: none;
              font-size: 14px;
              outline: none;
              border-radius: 5px;
              border: 1px solid #999;
              box-sizing: border-box;
              padding: 5px 10px;
            }
          }

          &.voucher {
            height: 105px;
            align-items: flex-start;
            margin-top: 10px;

            span.label {
              padding-top: 10px;
            }

            .img-wrapper {
              width: 220px;
              height: 100px;
              background-color: #fff;
              margin-left: 10px;
              border-radius: 5px;
              display: flex;
              flex-direction: column;
              justify-content: center;
              align-items: center;
              position: relative;
              border: 1px solid #999;

              .notice {
                padding-top: 10px;
                color: #999;
                font-size: 14px;
              }

              i {
                font-size: 20px;
                color: #999;
                cursor: pointer;
              }

              input.file-uploader {
                display: block;
                width: 220px;
                height: 100px;
                position: absolute;
                top: 0;
                left: 0;
                cursor: pointer;
                opacity: 0;
              }
              .pic-voucher {
                width: 220px;
                height: 100px;
              }
            }
          }
        }
      }
    }

    .submit-btn {
      width: 100%;
      margin-top: 30px;

      a {
        display: block;
        width: 298px;
        height: 38px;
        line-height: 38px;
        font-size: 20px;
        color: #f5f5f5;
        text-align: center;
        border-radius: 5px;
        margin: 0 auto 20px;
        cursor: pointer;

        &.btn-submit {
          background: @blue-d;
        }
        &.btn-cancel {
          background: #ccc;
        }
      }
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/pages/Apply2Refund.vue